document.addEventListener('DOMContentLoaded', () => {
    // Function to add selected items to the bag
    function addToBag(collection) {
        let products = document.querySelectorAll(`.product-section[data-collection="${collection}"] .product-item`);
        let cartItems = [];
        let summaryList = document.getElementById('summaryList');
        summaryList.innerHTML = ''; // Clear previous summary

        products.forEach(product => {
            let quantityInput = product.querySelector('.product-quantity');
            let quantity = parseInt(quantityInput.value);
            let productId = quantityInput.dataset.productId;
            let productName = product.querySelector('.product-name').textContent;

            if (quantity > 0 && !quantityInput.disabled) {
                cartItems.push({
                    id: productId,
                    quantity: quantity,
                });

                // Add to summary list
                let listItem = document.createElement('li');
                let nameSpan = document.createElement('span');
                nameSpan.textContent = productName;
                let quantitySpan = document.createElement('span');
                quantitySpan.textContent = quantity;
                listItem.appendChild(nameSpan);
                listItem.appendChild(quantitySpan);
                summaryList.appendChild(listItem);
            }
        });

        if (cartItems.length > 0) {
            fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: cartItems })
            })
            .then(response => {
                if (response.ok) {
                    return response.json();
                } else {
                    throw new Error('Network response was not ok.');
                }
            })
            .then(data => {
                // Display the summary popup
                const summaryPopup = document.getElementById('summaryPopup');
                summaryPopup.classList.add('show');

                // Update cart count without refreshing the page
                updateCartCount();

                // Attach event listeners to buttons
                document.getElementById('continueBtn').addEventListener('click', () => {
                    summaryPopup.classList.remove('show');
                });

                document.getElementById('viewBagBtn').addEventListener('click', () => {
                    window.location.href = '/cart';
                });
            })
            .catch(error => {
                console.error('Error:', error);
                displayErrorMessage('Something went wrong while adding items to the cart.');
            });
        } else {
            displayErrorMessage('Please select quantities for in-stock items before adding to the bag.');
        }
    }

    // Function to update cart count
    function updateCartCount() {
        fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
                // Assuming you have a cart count element with ID 'cart-count'
                const cartCountElement = document.getElementById('cart-count');
                if (cartCountElement) {
                    cartCountElement.textContent = cart.item_count;
                }
            })
            .catch(error => {
                console.error('Error updating cart count:', error);
            });
    }

    // Function to display error message
    function displayErrorMessage(message) {
        alert(message);
    }

    // More Info Toggle
    const infoButtons = document.querySelectorAll('.more-info-btn');

    infoButtons.forEach(button => {
        button.addEventListener('click', () => {
            const description = document.getElementById(button.getAttribute('aria-controls'));
            const isExpanded = button.getAttribute('aria-expanded') === 'true';
            description.classList.toggle('show');
            button.setAttribute('aria-expanded', !isExpanded);
            button.textContent = description.classList.contains('show') ? 'Less Info' : 'More Info';
        });
    });

    // Quantity Selector Functionality with Event Delegation
    document.body.addEventListener('click', event => {
        if (event.target.matches('.increase, .decrease')) {
            const button = event.target;
            const quantityInput = button.parentElement.querySelector('.product-quantity');
            if (!quantityInput.disabled) {
                let currentValue = parseInt(quantityInput.value) || 0;
                if (button.classList.contains('increase')) {
                    quantityInput.value = currentValue + 1;
                } else if (button.classList.contains('decrease') && currentValue > 0) {
                    quantityInput.value = currentValue - 1;
                }
            }
        }
    });

    // Prevent manual entry of invalid quantities
    const quantityInputs = document.querySelectorAll('.product-quantity');
    quantityInputs.forEach(input => {
        input.addEventListener('input', () => {
            let value = parseInt(input.value);
            if (isNaN(value) || value < 0) {
                input.value = 0;
            }
        });
    });

    // Image Zoom Overlay
    window.openOverlay = function(src) {
        const overlay = document.getElementById('imageOverlay');
        const overlayImage = document.getElementById('overlayImage');
        overlayImage.src = src;
        overlay.classList.add('show');
    };

    window.closeOverlay = function() {
        const overlay = document.getElementById('imageOverlay');
        overlay.classList.remove('show');
    };

    // Close overlay when clicking outside the image
    document.getElementById('imageOverlay').addEventListener('click', function(event) {
        if (event.target === this) {
            closeOverlay();
        }
    });

    // Function to open product image in overlay
    window.openProductImage = function(imageSrc) {
        const overlay = document.getElementById('imageOverlay');
        const overlayImage = document.getElementById('overlayImage');
        overlayImage.src = imageSrc;
        overlay.classList.add('show');
    };

    // Expose addToBag to the global scope
    window.addToBag = addToBag;
});
